import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { useState } from "react";
// components
import { CustomButton } from "@gl-shared/shared/ui";
import { CustomCheckbox } from "@gl-shared/shared/ui";
// actions
import { offersActionCreators } from "../../common/store/modules/offersModule";

const OfferTermsAndConditions = props => {
  const [conditionsCheckboxValue, setConditionsCheckboxValue] = useState(false);

  const handleGetStartedButton = () => {
    if (!conditionsCheckboxValue) {
      return null;
    }
    props.updateTermsAndConditions(props.handleFormMessage, props.handleSectionLoader);
  };

  return (
    <div className="row hotel-offers__box hotel-offers__initial">
      <div className="col-lg-6">
        <div className="ibox ">
          <div className="ibox-title">
            <h5>Hotel Offers</h5>
          </div>
          <div className="ibox-content hotel-offers__initial__text">
            In this area, you can create your own hotel offers. Like this you can add your products and services to the
            GET LOCAL Marketplace and sell them to your guests in the GET LOCAL Hotel Guest Platform or the GET LOCAL
            Hotel Concierge.
            <div className="spacing spacing--10px" />
            Some examples from other hotels include:
            <div className="spacing spacing--10px" />
            <ul>
              <li>F&B offers, such as hotel restaurants or brunch</li>
              <li>Wellness & Spa offers</li>
              <li>Upselling items such as a bottle of champagne, flowers or parking</li>
              <li>Pillow menues</li>
              <li>etc</li>
            </ul>
            In order to start, we will set up your hotel as a GET LOCAL Service Provider. <br />
            It’s just one click to get started.
            <div className="spacing spacing--10px" />
            <div className="terms-and-conditions__checkbox-container">
              <CustomCheckbox
                isChecked={conditionsCheckboxValue}
                value={conditionsCheckboxValue}
                iconSize={20}
                onClick={() => setConditionsCheckboxValue(!conditionsCheckboxValue)}
              />
              <span className="terms-and-conditions__checkbox-container--text">
                I agree to the{" "}
                <a href="/hotel/2023_01-Terms&Conditions-ServiceProvider.pdf" target="_blank">
                  terms & conditions
                </a>{" "}
                for GET LOCAL Service Providers and agree to sign up as a GET LOCAL Service Provider.
              </span>
            </div>
            <CustomButton
              mainClass="btn-green"
              customClasses="btn-green--md btn-green--height-xl hotel-offers__initial__get-started-btn"
              onClick={handleGetStartedButton}
              buttonText="GET STARTED"
              isDisabled={!conditionsCheckboxValue}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      updateTermsAndConditions: offersActionCreators.updateTermsAndConditions
    },
    dispatch
  );
};

export default connect(null, mapDispatchToProps)(OfferTermsAndConditions);
